// extracted by mini-css-extract-plugin
export default {"control":"control_control__n7LPL","addIcon":"control_addIcon__W61nX"};